import { Capacitor } from "@capacitor/core";
import { InAppReview } from "@capacitor-community/in-app-review";
import { trackEvent } from "../analytics";

const REVIEW_REQUESTED_AT_KEY = "yelo.reviewRequestedAt.v1";
const REVIEW_THROTTLE_MS = 60 * 24 * 60 * 60 * 1000;

let requestInFlight = false;
let sessionRequestedAt = 0;

export const maybeRequestReview = async (trigger: string): Promise<void> => {
  if (!Capacitor.isNativePlatform()) return;
  if (!Capacitor.isPluginAvailable("InAppReview")) return;

  trackEvent("review_prompt_eligible", { trigger });
  if (requestInFlight) return;

  let storedRequestedAt = 0;
  try {
    storedRequestedAt = Number(localStorage.getItem(REVIEW_REQUESTED_AT_KEY)) || 0;
  } catch {
    return;
  }
  if (Date.now() - Math.max(storedRequestedAt, sessionRequestedAt) < REVIEW_THROTTLE_MS) return;

  requestInFlight = true;
  await new Promise(resolve => setTimeout(resolve, 1200));
  try {
    await InAppReview.requestReview();
  } catch {}

  const requestedAt = Date.now();
  sessionRequestedAt = requestedAt;
  try {
    localStorage.setItem(REVIEW_REQUESTED_AT_KEY, String(requestedAt));
  } catch {}
  trackEvent("review_prompt_requested", { trigger });
  requestInFlight = false;
};
